import { observable, action, runInAction } from 'mobx'
import Api from '@api/yun_xuan/potentialCustomersApi'
class Store {
  @observable activeTab = 'seed'
  @observable detail = []
  @observable list = {}
  @observable customerCount = 0
  @observable title = ''
  @action
  changeTab = key => {
    this.activeTab = key
  }
  @action
  getDetail = async push_id => {
    const { success, data } = await Api.getPushDetail({ push_id })
    const { detail, list } = data || {}
    runInAction(() => {
      if (success) {
        this.detail = [detail]
        this.customerCount = detail.customer_count || 0
        this.title = detail.title || ''
        this.list = Object.assign(
          {},
          {
            seed: list,
            viewed: list.filter(({ is_viewed }) => is_viewed == 1),
            finished: list.filter(
              ({ merchant_customer_id }) => merchant_customer_id > 0
            )
          }
        )
      }
    })
  }
}

export default Store
